<template>
  <div
    v-if="isVisible"
    class="subscription-block"
  >
    <div class="container">
      <div class="head">
        <h2>Скидки, акции и новинки</h2>
        <p>Подписывайтесь на Email-рассылку</p>
      </div>
      <div class="body">
        <form
          class="input"
          @submit.prevent="sendForm"
        >
          <ui-input
            v-model.trim="email"
            :large="adaptive.isDesktop"
            clearable
            placeholder="Email"
            :error="!!validationError"
            @focus="validationError = ''"
            @blur="checkValidationError"
          />
          <div
            class="button"
          >
            <ui-button
              type="submit"
              text="Подписаться"
              :loading="progress"
              large
              wide
            />
          </div>
        </form>
        <!-- eslint-disable vue/no-v-html -->
        <span
          :class="{ error: validationError }"
          v-html="sanitize(substring)"
        />
        <!-- eslint-enable vue/no-v-html -->
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import validators from '@kit/ui-input/validators';

import { commonGtmEvents } from '@/gtm/common-gtm-events';
import { sanitize } from '@/utils/sanitize';

export default defineComponent({
  name: 'subscription-block',

  inject: ['adaptive'],

  emits: [
    'subscribe-gtm-event',
  ],

  setup() {
    return {
      sanitize,
    };
  },

  data() {
    return {
      email: '',
      error: '',
      progress: false,
      isVisible: true,
      validationError: '',
    };
  },

  computed: {
    substring() {
      return this.validationError
        ? this.validationError
        : `Нажимая на кнопку «Подписаться», вы принимаете
          <a target="_blank" href="/agreement">условия пользовательского соглашения</a> и
          <a target="_blank" href="/confidentiality">политики конфиденциальности</a>.`;
    },
  },

  methods: {
    checkValidationError() {
      const [regex, err] = validators.email[1];

      // проверяем наполнение email, чтобы не висела ошибка по дефолту
      if (this.email && !(new RegExp(regex)).test(this.email)) {
        this.validationError = err;
      } else {
        this.validationError = '';
      }
    },

    sendForm() {
      if (!this.email || !!this.validationError) {
        return;
      }

      this.progress = true;
      this.$store.$api.updateSubscription({ email: this.email }).then(() => {
        if (this.error) {
          this.error = '';
        }

        this.isVisible = false;
        this.$store.dispatch('notifications/create', {
          type: 'success',
          title: 'Успешно!',
          message: 'Вы подписались на рассылку',
        });
        // Google Tag Manager event
        commonGtmEvents.successSubscribe({
          url: window.location.href,
          email: this.email,
        });
        this.$emit('subscribe-gtm-event');
      }).catch(({ error = {} } = {}) => {
        this.error = error.detail || 'Ошибка!';
        this.$store.dispatch('notifications/create', {
          title: 'Ошибка!',
          message: 'Укажите E-mail', // пока временно хардкод, до доработок на стороне бэка
        });
      }).finally(() => {
        setTimeout(() => {
          this.progress = false;
        }, 500);
      });
    },
  },
});
</script>

<style lang="scss">
.subscription-block {
  height: 348px;
  padding: 32px 0 24px;
  background-color: $blue_l;

  .ui-input {
    min-height: initial;
  }

  .container {
    padding: 0 32px;

    .head {
      color: #fff;
      font-size: 14px;
      line-height: 20px;

      & > h2 {
        margin: 0;
        max-width: 250px;
        font-weight: bold;
        font-size: 28px;
        line-height: 40px;
        letter-spacing: 1px;
        text-transform: uppercase;
      }
    }

    .body {
      margin-top: 32px;
      font-size: 14px;
      line-height: 24px;
      color: #fff;

      .input {
        margin-top: 32px;
      }

      .button {
        margin-top: 16px;
      }

      .error {
        color: $red;
      }

      & > span {
        display: block;
        color: rgba(255, 255, 255, .64);
        font-size: 12px;
        line-height: 16px;
        margin-top: 16px;

        a {
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}

@include breakpoint("tablet") {
  .subscription-block {
    height: 164px;
    padding: 32px 0;

    .container {
      display: flex;

      .head {
        width: 50%;
        margin-right: 16px;
      }

      .body {
        width: 50%;
        margin-top: 4px;

        .input {
          display: flex;
          margin-top: 0;
        }
        .ui-input {
          flex: 1;
          &-input {
            border-radius: 4px 0 0 4px;
          }
        }

        .button {
          min-width: 118px;
          margin-top: 0;
        }

        .button > button {
          border-radius: 0 4px 4px 0;
        }

        span {
          line-height: 20px;
        }
      }
    }
  }
}

@include breakpoint("desktop") {
  .subscription-block {
    height: 176px;
    padding: 48px 0 44px;

    .container {

      .head {
        margin-right: 25px;

        & > h2 {
          max-width: 100%;
          font-size: 40px;
          line-height: 48px;
        }

        & > p {
          margin-top: 8px;
          font-size: 16px;
          line-height: 24px;
        }
      }

      .body {
        margin-top: 0;

        .input .button {
          min-width: 138px;
        }

        & > span {
          margin-top: 12px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
